// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
// import 'ant-design-vue/dist/antd.css';
import "ant-design-vue/dist/antd.less";
import Vue from "vue";
import Antd from "ant-design-vue";
import Vuex from "vuex";
import moment from "moment";
import "./assets/style/modify.less";
import { setCookie, getCookie, delCookie } from "./assets/js/cookie";
import App from "./App";
import router from "./router";
import store from "./store/store";
import api from "./api";
import Axios from "axios";
Vue.prototype.$http = Axios;
import userRight from "./assets/js/userRight";
import qs from "qs";
Vue.prototype.$qs = qs; //qs全局挂载在vue实例上

import Video from "video.js"; //展示播放视频
import "video.js/dist/video-js.css";

// 引入echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;


Vue.use(Vuex);
Vue.use(Antd);
Vue.prototype.$api = api;
Vue.prototype.$userRight = userRight;

Vue.config.productionTip = false;
Vue.prototype.$cookieStore = {
  setCookie,
  getCookie,
  delCookie
};
const Urls = process.env.NODE_ENV === 'production' ? '/storage/uploadImage' : '/api/storage/uploadImage';
Vue.prototype.uploaddUrl = Urls;
router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const arrss = [-1, {}];
  if (to.name != "userManage" && to.name != "detail") {
    localStorage.removeItem("userManagePagesize"); //清除用户管理缓存
    localStorage.removeItem("userCurrent");
  }
  if (userInfo) {
    store.state.userInfo = userInfo;
    next();
  } else if (to.path === "/login") {
    next();
  } else {
    next({
      path: "/login"
    });
  }
});
Vue.filter("dateformat", (dataStr, pattern = "YYYY-MM-DD HH:mm:ss") =>
  moment(dataStr).format(pattern)
);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js